module.exports = __webpack_public_path__ + "static/media/intelligent-monitoring.de3cd234.jpeg";